const USERS_KEY = "dbs.users.v1";
const AUTH_USER_KEY = "dbs.auth.user";
const LEGACY_AUTH_PHONE_KEY = "dbs.auth.phone";

const safeJsonParse = (value, fallback) => {
  try {
    if (value == null) return fallback;
    const parsed = JSON.parse(value);
    return parsed == null ? fallback : parsed;
  } catch {
    return fallback;
  }
};

const isPlainObject = (value) => {
  return (
    value != null &&
    typeof value === "object" &&
    !Array.isArray(value)
  );
};

const readUsers = () => {
  const raw = window.localStorage.getItem(USERS_KEY);
  const parsed = safeJsonParse(raw, {});
  return isPlainObject(parsed) ? parsed : {};
};

const writeUsers = (users) => {
  window.localStorage.setItem(USERS_KEY, JSON.stringify(users));
};

export const getAuthUser = () => {
  const raw = window.localStorage.getItem(AUTH_USER_KEY);
  const parsed = safeJsonParse(raw, null);
  if (parsed && isPlainObject(parsed))
    return parsed;

  const legacyPhone = window.localStorage.getItem(LEGACY_AUTH_PHONE_KEY);
  if (legacyPhone) {
    return {
      id: `phone:${legacyPhone}`,
      provider: "phone",
      phone: legacyPhone,
      createdAt: new Date().toISOString(),
    };
  }

  return null;
};

export const setAuthUser = (user) => {
  window.localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
  if (user?.phone) {
    window.localStorage.setItem(LEGACY_AUTH_PHONE_KEY, String(user.phone));
  }
};

export const clearAuth = () => {
  window.localStorage.removeItem(AUTH_USER_KEY);
  window.localStorage.removeItem(LEGACY_AUTH_PHONE_KEY);
};

const normalizePhone = (phone) => String(phone ?? "").trim();

export const loginOrRegisterWithPhone = (phone) => {
  const normalized = normalizePhone(phone);
  if (!normalized) return null;

  const id = `phone:${normalized}`;
  const users = readUsers();

  const existing = users?.[id];
  const user =
    existing ??
    {
      id,
      provider: "phone",
      phone: normalized,
      createdAt: new Date().toISOString(),
    };

  if (!existing) {
    const nextUsers = isPlainObject(users) ? users : {};
    nextUsers[id] = user;
    writeUsers(nextUsers);
  }

  setAuthUser(user);
  return user;
};

export const loginOrRegisterWithProvider = (provider) => {
  const safeProvider = String(provider ?? "").trim().toLowerCase();
  if (!safeProvider)
    return null;

  const id = `${safeProvider}:default`;
  const users = readUsers();

  const existing = users?.[id];
  const user =
    existing ??
    {
      id,
      provider: safeProvider,
      createdAt: new Date().toISOString(),
    };

  if (!existing) {
    const nextUsers = isPlainObject(users) ? users : {};
    nextUsers[id] = user;
    writeUsers(nextUsers);
  }

  setAuthUser(user);
  return user;
};
